import type { PostHog } from "posthog-js";
import { IMPERSONATION_EVENT_PROPERTY } from "./constants";

/**
 * Resets the PostHog identity at a sign-out or impersonation boundary and clears the
 * impersonation marker, so a stale registered `is_impersonated` can never ride along on the next
 * person's events.
 *
 * @param posthog - The PostHog client from `usePostHog()`, or null/undefined when not loaded.
 */
export function resetPostHogSession(posthog: Pick<PostHog, "reset" | "unregister"> | null | undefined): void {
  if (!posthog) return;
  posthog.reset();
  posthog.unregister(IMPERSONATION_EVENT_PROPERTY);
}
